<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    :close-on-content-click="false"
    min-width="250px"
    v-model="menuState"
  >
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on" class="mr-2">{{ developer }}</v-btn>
    </template>

    <v-list>
      <v-list-group v-for="(item, index) in devMenus" :key="index">
        <template v-slot:activator>
          <v-list-item-icon class="mr-5">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </template>

        <v-list-item
          v-for="(child, childIndex) in item.children"
          :key="childIndex"
          @click="openUrl(child.type, child.url, child.page)"
        >
          <v-list-item-icon class="mr-5 pl-1">
            <v-icon small>mdi-checkbox-blank-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ child.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from "pinia";
import { useLocalStore } from "../../../store/local";
import { devMenus } from "../../../router/dev";
import { openUrl } from "../../../utils/helper";

export default {
  name: "AppBarDevMenu",

  data() {
    return {
      devMenus,
      menuState: false,
    };
  },

  computed: {
    items() {
      const result = [];

      for (let i = 0; i < devMenus.length; i++) {
        const group = devMenus[i];
        result.push({
          title: group.title,
          icon: group.icon,
        });

        for (let j = 0; j < group.children.length; j++) {
          result.push(group.children[j]);
        }
      }

      return result;
    },
    ...mapState(useLocalStore, ["developer"]),
  },

  methods: {
    openUrl(type, url, page) {
      this.menuState = false;

      if (type == "url") openUrl(type, url);
      else if (type == "page") this.$router.push("/pages/" + page);
      else this.$router.push(url);
    },
  },
};
</script>